"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _Asset = _interopRequireDefault(require("../../Asset"));

var _AssetsSummaryFooter = _interopRequireDefault(require("./AssetsSummaryFooter"));

var _UploadButton = _interopRequireDefault(require("./UploadButton"));

var _When = _interopRequireDefault(require("../../../../../../../common/components/When"));

require("../styles/_asset-selection.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function onUpdateLabelsForAsset(assetId, assignedLabels, updateProject) {
  return function (labelIds) {
    var newLabels = _objectSpread({}, assignedLabels, _defineProperty({}, assetId, labelIds));

    updateProject({
      assignedLabels: newLabels
    }, {
      override: true
    });
  };
}

var AssetSelection = /*#__PURE__*/function (_Component) {
  _inherits(AssetSelection, _Component);

  var _super = _createSuper(AssetSelection);

  function AssetSelection() {
    var _this;

    _classCallCheck(this, AssetSelection);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (files) {
      var onSelectFiles = _this.props.onSelectFiles;

      if (!files.length) {
        return;
      }

      onSelectFiles(files);

      _this._filesRef.removeFiles();

      var scrollableAssets = document.querySelector('.asset-selection__assets');

      if (!scrollableAssets) {
        return;
      }

      scrollableAssets.scrollTo({
        top: scrollableAssets.scrollHeight,
        behavior: 'smooth'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "viewAssetDetails", function (assetId) {
      return function () {
        _this.setState({
          assetDetailsId: assetId
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "closeDetailsModal", function () {
      _this.setState({
        assetDetailsId: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setFilesRef", function (el) {
      _this._filesRef = el;
    });

    _this.state = {};
    return _this;
  }

  _createClass(AssetSelection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          visibleAssetIds = _this$props.visibleAssetIds,
          onSelectFiles = _this$props.onSelectFiles,
          selectedAssets = _this$props.selectedAssets,
          onSelectAsset = _this$props.onSelectAsset,
          apolloClient = _this$props.apolloClient,
          updateProject = _this$props.updateProject,
          labels = _this$props.labels,
          assignedLabels = _this$props.assignedLabels,
          onRemoveAssets = _this$props.onRemoveAssets,
          toggleSourceFiles = _this$props.toggleSourceFiles,
          allAssetIds = _this$props.allAssetIds,
          canUpdateVideo = _this$props.canUpdateVideo,
          hasArchiveAssetsPermission = _this$props.hasArchiveAssetsPermission,
          hasDeleteAssetsPermission = _this$props.hasDeleteAssetsPermission,
          onArchiveAsset = _this$props.onArchiveAsset,
          onDeleteAsset = _this$props.onDeleteAsset,
          onSaveAssetDetails = _this$props.onSaveAssetDetails,
          videoName = _this$props.videoName;
      var assetDetailsId = this.state.assetDetailsId;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "asset-selection"
        }, /*#__PURE__*/_react.default.createElement(_commonReact.ManageAssetModal, {
          assetId: assetDetailsId,
          apiClient: apolloClient,
          isVisible: Boolean(assetDetailsId),
          onClose: this.closeDetailsModal,
          onSave: onSaveAssetDetails
        }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactFiles.default, {
          ref: this.setFilesRef,
          onChange: this.onChange,
          minFileSize: 1,
          clickable: false,
          dropActiveClassName: "asset-selection--dragging"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "asset-selection__drag"
        }, /*#__PURE__*/_react.default.createElement("p", null, "Drop files to instantly upload them to:"), /*#__PURE__*/_react.default.createElement("p", null, videoName)), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('asset-selection__assets')
        }, /*#__PURE__*/_react.default.createElement(_When.default, {
          isTruthy: onSelectFiles && canUpdateVideo
        }, /*#__PURE__*/_react.default.createElement(_UploadButton.default, {
          onSourceFiles: toggleSourceFiles,
          onBrowseFiles: (0, _lodash.default)(this._filesRef, 'openFileChooser')
        })), visibleAssetIds.map(function (assetId) {
          return (/*#__PURE__*/_react.default.createElement(_Asset.default, {
              key: assetId,
              onChange: onSelectAsset(assetId),
              assetId: assetId,
              selected: selectedAssets.includes(assetId),
              onUpdateLabelsForAsset: onUpdateLabelsForAsset(assetId, assignedLabels, updateProject),
              selectedLabels: assignedLabels[assetId],
              labels: labels,
              onRemoveAssetFromVideo: onRemoveAssets({
                assetId: assetId
              }),
              onRemoveAssetFromProject: onRemoveAssets({
                assetId: assetId,
                removeFromProject: true
              }),
              viewAssetDetails: _this2.viewAssetDetails(assetId),
              canUpdateVideo: canUpdateVideo,
              hasArchiveAssetsPermission: hasArchiveAssetsPermission,
              hasDeleteAssetsPermission: hasDeleteAssetsPermission,
              onArchiveAsset: onArchiveAsset(assetId),
              onDeleteAsset: onDeleteAsset(assetId)
            })
          );
        })))), /*#__PURE__*/_react.default.createElement(_AssetsSummaryFooter.default, {
          assetIds: allAssetIds
        }))
      );
    }
  }]);

  return AssetSelection;
}(_react.Component);

exports.default = AssetSelection;